module.exports = __webpack_public_path__ + "static/media/ico-info-orange.7b33262a.svg";